module.exports = __webpack_public_path__ + "bj.svg?486ce25912ff76c58d4404ebdd66a704";


//////////////////
// WEBPACK FOOTER
// ./src/images/flags/4x3/bj.svg
// module id = 1007
// module chunks = 27